import React from 'react';
import YouTube from 'react-youtube';

const onEnd = (event) => {
    event.target.seekTo(0);
    event.target.stopVideo();
}

function HorseHightlight({ horse, hipImage }) {
    const { enhancedhorsephoto_set = [] } = horse;
    let imgUrl = null;

    if (hipImage) {
        imgUrl = hipImage;
    }
    const videoId = horse.enhanced_featured_video && horse.enhanced_featured_video.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
    const videoView = videoId && (
        <div
            className="embed-responsive embed-responsive-16by9"
            style={{
                clear: 'both',
            }}
        >
            <YouTube
                videoId={videoId[1]}
                opts={{
                    width: '100%',
                    playerVars: {
                        autoplay: 0,
                        rel: 0,
                        modestbranding: 1,
                    }
                }}
                className="embed-responsive-item"
                onEnd={onEnd}
            />
        </div>
    );

    const defaultImage = imgUrl && (<img className="img-fluid" src={`${imgUrl}`} />);
    return (
        <div className="col-lg horse-photos">
            <div>
            { defaultImage }
            {horse.enhanced_photo_caption && <p className="photo-caption" dangerouslySetInnerHTML={{ __html: horse.enhanced_photo_caption }} />}
            </div>
        </div>
    );
}

export default HorseHightlight;
